/**
 * SMS map-people icons — migrated to typed `@tiaki/http-client` per ADR 113.
 */
import { client } from '../lib/http-client';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  return result.data as T;
}

/**
 * @deprecated Icon URIs are now automatically set based on POI type
 */
export interface POIItem {
  name: string;
  display_name: string;
  icon: string;
  icon_url: string | null;
}

export interface POIConfig {
  poi: POIItem[];
  default_icon: string;
  default_icon_url: string | null;
}
export interface POIConfigResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: POIConfig;
}
export interface MapPeopleIconsFilters {
  school?: number;
  page?: number;
  page_size?: number;
  ordering?: string;
}

export async function getMapPeopleIcons(): Promise<POIConfigResponse> {
  const result = await client.GET('/api/v2/map-people-icons/', {});
  return unwrap(result) as unknown as POIConfigResponse;
}
